<div class="review-container">
  <div class="success-message">
    <div class="left">
      <!--<img src="assets/img/tick_green.png">-->
      <i class="icon-controls-approvalL" role="img" aria-hidden="true"></i>
    </div>
    <div>
      <h2>We received your request.</h2>
    </div>
    <p>We are processing your request. We will send you an email when processing is complete.</p>
  </div>    
  <div class="outer heading">
    <div> Foundation account </div>
    <label id="fan">{{fan}} </label>

  </div>

  <div class="outer" *ngIf="singleDevice">
    <div> Device </div>
    <label id="ctn">{{selectedCtn}} </label>

  </div>

  <div class="outer">
    <div id="dateRange"> {{dateRange}} </div>
    <label id="date">
{{startDate}}- {{endDate}} </label>

  </div>

  <div class="outer">
    <div> Report format </div>
    <label id="format">{{format}} </label>

  </div>

  <div class="buttons-section col-sm-12 col-md-12 text-right cta">
    <a href="javascript:void(0)" role="button" class="btn btn-secondary" (click)="backToCallingPage()" attr.aria-label="OK">OK</a>

  </div>
  <div class="clearfix"></div>

</div>